import { render, staticRenderFns } from "./BaseExperiment.vue?vue&type=template&id=47561f74"
import script from "./BaseExperiment.vue?vue&type=script&lang=ts"
export * from "./BaseExperiment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports